import {
  ID_ADD, TOKEN_ADD, PROJECT_ADD,
  NEW_FILE, MAX_FILE, APP_ACTIVE,
  SHOW_APP, LOGIN_APP, ADD_ALIVE,
  KEEP_FALSE, NEW_PKG, DONE_PKG,
  ADD_SCROLL, ALERT_WARN, SHOW_TRANSFER,
  SET_INFO, SENT_FILE, ACTIVE_ALIVE,
  ROLE_ADD, SHOW_LANG, ADD_SIZE,
  SHOW_DOWN,
  USER_ADD, SPACE_ADD, OTHER_SHOW,
  SPACELIST_SHOW, LEFT_SHOW, BOX_SHOW,
  EL_UPDATE, VER_CHECK, SHOW_KICK,
  SHOW_MSG, SHOW_FLOATING, EL_TRANSFER,
  SHOW_DOWNMSG, PERMISSION_ADD
} from './types'
const mutations = {
  [ID_ADD] (state, id) {
    state.userInfo.id = id
  },
  [TOKEN_ADD] (state, token) {
    state.userInfo.token = token
  },
  [PROJECT_ADD] (state, id) {
    state.project.id = id
  },
  [NEW_FILE] (state, el) {
    state.el.newFile = el
  },
  [MAX_FILE] (state, el) {
    state.el.maxFile = el
  },
  [APP_ACTIVE] (state, el) {
    state.app.type = el
  },
  [SHOW_APP] (state, el) {
    state.app.show = el
  },
  [SHOW_TRANSFER] (state, el) {
    state.transfer.transferShow.show = el.show
    state.transfer.transferShow.type = el.type
  },
  [LOGIN_APP] (state, el) {
    state.app.login = el
  },
  [ADD_ALIVE] (state, el) {
    state.transfer.aliveList = el
  },
  [KEEP_FALSE] (state, el) {
    state.clearKeep = el
  },
  [NEW_PKG] (state, el) {
    state.notice.newPkg = el
  },
  [DONE_PKG] (state, el) {
    state.notice.donePkg = el
  },
  [ADD_SCROLL] (state, el) {
    state.scroll = el
  },
  [ALERT_WARN] (state, el) {
    state.notice.alertWarn = el
  },
  [SET_INFO] (state, el) {
    state.app.info.newVersion = el.newVersion
    state.app.info.appVersion = el.appVersion
    state.app.info.downloadUrl = el.downloadUrl
  },
  [SENT_FILE] (state, el) {
    state.el.sentFile = el
  },
  [ACTIVE_ALIVE] (state, el) {
    state.notice.alertAlive = el
  },
  [ROLE_ADD] (state, role) {
    state.userInfo.role = role
  },
  [SHOW_LANG] (state, el) {
    state.el.showLang = el
  },
  [ADD_SIZE] (state, el) {
    state.size = el
  },
  [SHOW_DOWN] (state, el) {
    state.el.showDown = el
  },
  // [PASS_DOWN] (state, el) {
  //   state.el.passDown = el
  // },
  //
  [USER_ADD] (state, data) {
    state.user.name = data.name
    state.user.token = localStorage.getItem('token')
    state.user.uid = data.uid
    state.user.imgUrl = data.imgUrl
    state.user.email = data.email
    state.user.role = data.role
  },
  [SPACE_ADD] (state, data) {
    state.space = data
  },
  [PERMISSION_ADD] (state, data) {
    state.permissions.permission = data.permission
    state.permissions.codes = data.codes
  },
  [OTHER_SHOW] (state, data) {
    state.show.other = data
  },
  [SPACELIST_SHOW] (state, data) {
    state.show.spaceList = data
  },
  [LEFT_SHOW] (state, data) {
    state.show.left = data
  },
  [BOX_SHOW] (state, data) {
    state.show.box = data
  },
  [EL_UPDATE] (state, data) {
    state.updateEl = data
  },
  [VER_CHECK] (state, data) {
    state.app.versionCheck = data
  },
  [SHOW_KICK] (state, data) {
    state.notice.infoKick = data
  },
  [SHOW_MSG] (state, data) {
    state.show.msg = data
  },
  [SHOW_FLOATING] (state, data) {
    state.show.floating = data
  },
  [EL_TRANSFER] (state, data) {
    state.el.startTransfer = data
  },
  [SHOW_DOWNMSG] (state, data) {
    state.el.showDownMsg = data
  },
}
export default mutations
